var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIronBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "iron_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 198",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1063",
    d: "M11.405 12a1.393 1.393 0 0 0 1.26-.7A1.54 1.54 0 0 1 14 10.5h6a1.5 1.5 0 0 1 1.5 1.5v1.5H8a6 6 0 0 0-6 6v3A1.5 1.5 0 0 0 3.5 24H23a1.5 1.5 0 0 0 1.5-1.5V21a4.494 4.494 0 0 0 4.5-4.5v-6A1.5 1.5 0 0 1 30.5 9 1.5 1.5 0 0 0 32 7.5 1.5 1.5 0 0 0 30.5 6a4.494 4.494 0 0 0-4.5 4.5v6a1.5 1.5 0 0 1-1.5 1.5v-6A4.494 4.494 0 0 0 20 7.5h-6a4.506 4.506 0 0 0-3.945 2.325A1.5 1.5 0 0 0 11.405 12z",
    transform: "translate(1 3)",
    style: {
      fill: "#b0b0b0"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronBlack24Dp);
export default __webpack_public_path__ + "static/media/iron_black_24dp.391a2de5abb2448aed354712198ef079.svg";
export { ForwardRef as ReactComponent };